import { FieldNames } from 'app/models/fields/names';
import { LOAN_OFFICER_REROUTE_FORM_OPTIONS } from 'app/models/options/options';
import { Questions } from './Questions';
import { SHARED } from './shared';
import { Select } from '../../components/FormFields/Select';
import { Integer } from '../../components/FormFields/Integer';

export const LOAN_OFFICER_QUESTIONS: Questions = new Questions([
  {
    id: 1001,
    ...SHARED[FieldNames.firstName],
    name : FieldNames.brokerLoanOfficerFirstName,
  },
  {
    id: 1002,
    ...SHARED[FieldNames.lastName],
    name : FieldNames.brokerLoanOfficerLastName,
  },
  {
    id: 1003,
    ...SHARED[FieldNames.email],
    name : FieldNames.brokerLoanOfficerEmail,
  },
  {
    id: 1004,
    ...SHARED[FieldNames.phone],
    name : FieldNames.brokerLoanOfficerPhone,
  },
  {
    id           : 1005,
    component    : Integer,
    label        : 'Company NMLS',
    name         : FieldNames.brokerLoanOfficerCompanyNMLS,
  },
  {
    id: 1006,
    label : 'Form',
    name: FieldNames.redirectForm,
    component: Select,
    options: LOAN_OFFICER_REROUTE_FORM_OPTIONS,
  },
]);
